export { Page as default } from '@ui/views/Stake';
export { getStaticPaths, getStaticProps } from '@ui/views/Stake/getStatic';
